module.exports = __webpack_public_path__ + "img/20241224.2b898a32.png";